export const getCheckboxItemConfig = <T>(option: T) => ({
  id: option,
  key: option,
  value: option,
})
